$(".widget_wc-donation-widget style").remove();

$(window).on("load", function () {
  /** Uncheck the checkbox with name wc_donation_gift_aid_checkbox */
  $("input[name='wc_donation_gift_aid_checkbox']").prop("checked", false);

  /**
   * Add text to the patrons donation cards - this is a hacky fix
   * because the donation plugin does not allow for custom text to be added
   */
  $(".wc-label-button").each(function () {
    var isPatron = $(this).parents(".tab_container").hasClass("is-patron");

    if (isPatron) {
      $(this).prepend(
        `<span class="label-description">Select a level and click join us</span>`
      );
    }
  });

  // Handle donation button click
  $(document).on(
    "click",
    ".button.wc-donation-f-submit-donation",
    function (e) {
      var $button = $(this);
      var originalText = $button.text();
      var tabContent = $button.closest(".tab_content");
      var campVal = tabContent.find(".wc_donation_camp").val();
      var randVal = tabContent.find(".wp_rand").val();
      var donationPrice = tabContent
        .find(".donate_" + campVal + "_" + randVal)
        .val();

      if (!donationPrice) {
        return;
      }

      // Add spinner and "Loading..." text
      $button.html(
        '<span class="donation-loading-spinner"></span><span class="text">Loading</span>'
      );
    }
  );
});
